<div class="tag-preview">
  <ng-container *ngIf="currentTag | async as tag; else loading">
    <app-tag [color]="tag.color" class="tag">{{tag.name}}</app-tag>
  </ng-container>
</div>

<p class="confirmation-text" data-testid="confirmation-text">
  {{tokens.deleteConfirmation | translate}}
</p>

<ng-template #loading>
  <div class="tag-skeleton">
    <ask-skeleton [barsHeight]="24" [radius]="10" style="height: 24px;"/>
  </div>
</ng-template>
